// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_g4-0";
export var actionModalContentContainer = "_g4-1";
export var createTagButton = "_g4-2";
export var footerContainer = "_g4-7";
export var fullWidthDivider = "_g4-3";
export var hasCreateTagButton = "_g4-4";
export var noCreateTagButton = "_g4-5";
export var tagsContainer = "_g4-6";
export var tagsModalContentContainer = "_g4-8";